<template>
  <el-col>
      <w-timeline-chart :active="active" @clickChart="onClickChart"/>
      <component v-for="chartView in templateCharts" :key="chartView.templateId" :is="chartView.componentName" :active="active" :chartVisible="chartView.visible" @clickChart="onClickChart" @clickAddButton="onClickAddButton" />
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import AnalysisMixin from '@/mixins/performance/analysis';
import perfCommonApi from '@/api/performance/common';

import WTimelineChart from '@/views/performance/node/analysis/components/TimelineChart';
// UPS
import WUpsVoltageAnalysisChart from './components/chart/UpsVoltageAnalysisChart';
import WUpsCurrentAnalysisChart from './components/chart/UpsCurrentAnalysisChart';
import WUpsFrequencyAnalysisChart from './components/chart/UpsFrequencyAnalysisChart';
import WUpsTempAnalysisChart from './components/chart/UpsTempAnalysisChart';
import WUpsBatteryCurrentAnalysisChart from './components/chart/UpsBatteryCurrentAnalysisChart';
import WUpsBatteryVoltageAnalysisChart from './components/chart/UpsBatteryVoltageAnalysisChart';
import WUpsCapacityAnalysisChart from './components/chart/UpsCapacityAnalysisChart';

// 항온항습기
import WFthehygroTempAnalysisChart from './components/chart/FthehygroTempAnalysisChart';
import WFthehygroHumidityAnalysisChart from './components/chart/FthehygroHumidityAnalysisChart';

// 온/습도 센서
import WFthTempAnalysisChart from './components/chart/FthTempAnalysisChart';
import WFthHumidityAnalysisChart from './components/chart/FthHumidityAnalysisChart';

// 누수센서
import WFwldsLossofflowAnalysisChart from './components/chart/FwldsLossofflowAnalysisChart';

// 소방설비
import WFiredsAnalysisChart from './components/chart/FiredsAnalysisChart';

// 분전반
import WFvsbmsVoltageAnalysisChart from './components/chart/FvsbmsVoltageAnalysisChart';
import WFvsbmsCurrentAnalysisChart from './components/chart/FvsbmsCurrentAnalysisChart';
import WFvsbmsPowerAnalysisChart from './components/chart/FvsbmsPowerAnalysisChart';
import WFvsbmsPowerFactorAnalysisChart from './components/chart/FvsbmsPowerFactorAnalysisChart';

// 도어센서
import WDoorStatusAnalysisChart from './components/chart/DoorStatusAnalysisChart';

// 에어플로우
import WAirflowAnalysisChart from './components/chart/AirflowAnalysisChart';

// 전력 분배
import WPdusCurrentAnalysisChart from './components/chart/PdusCurrentAnalysisChart';
import WPdusVoltageAnalysisChart from './components/chart/PdusVoltageAnalysisChart';
import WPdusPowerAnalysisChart from './components/chart/PdusPowerAnalysisChart';

// 소음 센서
import WNoiseAnalysisChart from './components/chart/NoiseAnalysisChart';

// 발전기 감시
import WFgcuVoltageAnalysisChart from './components/chart/FgcuVoltageAnalysisChart';
import WFgcuPowerAnalysisChart from './components/chart/FgcuPowerAnalysisChart';
import WFgcuCurrentAnalysisChart from './components/chart/FgcuCurrentAnalysisChart';
import WFgcuOilPressAnalysisChart from './components/chart/FgcuOilPressAnalysisChart';
import WFgcuWaterTempAnalysisChart from './components/chart/FgcuWaterTempAnalysisChart';
import WFgcuGenFrequencyAnalysisChart from './components/chart/FgcuGenFrequencyAnalysisChart';

// 정류기 센서
import WFrtVoltageAnalysisChart from './components/chart/FrtVoltageAnalysisChart';
import WFrtCurrentAnalysisChart from './components/chart/FrtCurrentAnalysisChart';
import WFrtFrequencyAnalysisChart from './components/chart/FrtFrequencyAnalysisChart';
import WFrtLoadFactorAnalysisChart from './components/chart/FrtLoadFactorAnalysisChart';
import WFrtPowerFactorAnalysisChart from './components/chart/FrtPowerFactorAnalysisChart';

// 선형 온도
import WFtemp1AnalysisChart from './components/chart/Ftemp1AnalysisChart';
import WFtemp6AnalysisChart from './components/chart/Ftemp6AnalysisChart';
import WFtemp11AnalysisChart from './components/chart/Ftemp11AnalysisChart';
import WFtemp16AnalysisChart from './components/chart/Ftemp16AnalysisChart';

export default {
  name: 'WPerformanceSensorAnalysisChart',
  components: {
    WTimelineChart,
    WUpsVoltageAnalysisChart,
    WUpsCurrentAnalysisChart,
    WUpsFrequencyAnalysisChart,
    WUpsTempAnalysisChart,
    WUpsBatteryCurrentAnalysisChart,
    WUpsBatteryVoltageAnalysisChart,
    WUpsCapacityAnalysisChart,
    WFthehygroTempAnalysisChart,
    WFthehygroHumidityAnalysisChart,
    WFthTempAnalysisChart,
    WFthHumidityAnalysisChart,
    WFwldsLossofflowAnalysisChart,
    WFiredsAnalysisChart,
    WFvsbmsVoltageAnalysisChart,
    WFvsbmsCurrentAnalysisChart,
    WFvsbmsPowerAnalysisChart,
    WFvsbmsPowerFactorAnalysisChart,
    WDoorStatusAnalysisChart,
    WAirflowAnalysisChart,
    WPdusCurrentAnalysisChart,
    WPdusVoltageAnalysisChart,
    WPdusPowerAnalysisChart,
    WNoiseAnalysisChart,
    WFgcuVoltageAnalysisChart,
    WFgcuPowerAnalysisChart,
    WFgcuCurrentAnalysisChart,
    WFgcuOilPressAnalysisChart,
    WFgcuWaterTempAnalysisChart,
    WFgcuGenFrequencyAnalysisChart,
    WFrtVoltageAnalysisChart,
    WFrtCurrentAnalysisChart,
    WFrtFrequencyAnalysisChart,
    WFrtLoadFactorAnalysisChart,
    WFrtPowerFactorAnalysisChart,
    WFtemp1AnalysisChart,
    WFtemp6AnalysisChart,
    WFtemp11AnalysisChart,
    WFtemp16AnalysisChart,
  },
  mixins: [AnalysisMixin],
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler() {
        if (!this.active) {
          return;
        }
        this.$store.dispatch('setPlotLineDatetime', null);
        this.loadData();
      },
    },
  },
  methods: {
    /**
     * 사용자 별 분석 그래프 설정 데이터를 가져와서 표현할 자원의 컴포넌트를 설정한다.
     * @author jda
     * @return {[type]} [description]
     */
    loadData() {
      if (!isEmpty(this.templateCharts)) {
        map(this.templateCharts, (record) => {
          record.visible = false;
        });
      }

      // TODO: parameter : managetypeId, managetypeKey, objtypeId 필요
      const obj = this.selectedNode.obj;
      const params = {
        managetypeId: obj.objManagetypeId,
        objtypeId: obj.objtypeId || null,
        managetypeKey: obj.managetypeKey || 'FS',
      };
      perfCommonApi.getPerfChartTypeByMgr(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const templateCharts = [];

          const objtypeId = this.selectedNode.obj.objtypeId;
          result.forEach((record) => {
            // FIXME: 설계 완료 후 parameter로 managetypeId를 넘길 것이므로 managetypeId 비교 로직 뺄것.
            if (record.managetypeId === 'FMS' && record.objtypeId === objtypeId) {
              templateCharts.push({
                componentName: `W${upperFirst(camelCase(record.chartTypeId))}AnalysisChart`,
                templateId: record.chartTypeId,
                visible: true,
              });
            }
          });
          this.templateCharts = templateCharts;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/sensor/PerformanceSensorAnalysisChart.vue